var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2556 10.4449C19.8134 10.959 19.8134 11.7902 19.2556 12.2551L13.1306 18.3801C12.6657 18.9379 11.8345 18.9379 11.3204 18.3801L8.25791 15.3176C7.74932 14.8527 7.74932 14.0215 8.25791 13.5074C8.77197 12.9988 9.60322 12.9988 10.0681 13.5074L12.2501 15.6457L17.4454 10.4449C17.9595 9.93633 18.7907 9.93633 19.2556 10.4449Z",
    fill: "#00A524"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14 0C16.0125 0 17.7625 1.13203 18.643 2.79453C20.4422 2.19297 22.4273 2.6775 23.8984 4.10047C25.3203 5.52344 25.7086 7.55781 25.2055 9.35703C26.868 10.2375 28 11.9875 28 14C28 16.0125 26.868 17.7625 25.2055 18.643C25.7578 20.4422 25.3203 22.4273 23.8984 23.8984C22.4273 25.3203 20.4422 25.7086 18.643 25.2055C17.7625 26.868 16.0125 28 14 28C11.9875 28 10.2375 26.868 9.35703 25.2055C7.55781 25.7578 5.52344 25.3203 4.10047 23.8984C2.6775 22.4273 2.24219 20.4422 2.79453 18.643C1.13203 17.7625 0 16.0125 0 14C0 11.9875 1.13203 10.2375 2.79453 9.35703C2.19297 7.55781 2.6775 5.52344 4.10047 4.10047C5.52344 2.6775 7.55781 2.24219 9.35703 2.79453C10.2375 1.13203 11.9875 0 14 0ZM19.2555 12.2555C19.8133 11.7906 19.8133 10.9594 19.2555 10.4453C18.7906 9.93672 17.9594 9.93672 17.4453 10.4453L12.25 15.6461L10.068 13.5078C9.60313 12.9992 8.77188 12.9992 8.25781 13.5078C7.74922 14.0219 7.74922 14.8531 8.25781 15.318L11.3203 18.3805C11.8344 18.9383 12.6656 18.9383 13.1305 18.3805L19.2555 12.2555Z",
    fill: "#00A524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSecurity);
export default __webpack_public_path__ + "static/media/check-security.d4a0ce80ddc85520af4f07265a81f59d.svg";
export { ForwardRef as ReactComponent };